import { createSlice } from '@reduxjs/toolkit'
import allQuestion from '../../common/const'

const initialState = {
  questions: allQuestion,
}

const authSlice = createSlice({
  name: 'questionnaire',
  initialState,
  reducers: {
    setAllQuestions: (state, action) => {
      state.questions = action.payload
    },
  },
})

export const { setShowQuestion, setAllQuestions } = authSlice.actions

export default authSlice.reducer
